import React from 'react'

export default function() {
  return <h4>{process.env.REACT_APP_GIT_HASH}</h4>
}
